// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"262":"c79247cb","380":"ea78726e"}[chunkId] + ".css";
};